import { useLayoutEffect, useRef } from 'react';
import {
  Item,
  FixedGrid,
  itemInGrid,
} from 'MonadomCoreUI';
import { TextLine3 } from './UtilComponents';
import {
  ForDevelopment
} from './dev/developmentUI';
import {
  handleClickDeckNumber,
  handleClickSaveDeck,
} from './buildDeck';
import {
  useGlobalStateSelector,
  words,
} from './globalState';
import {
  handleClickGoTop,
} from './monadomCore';
import iconExpand from './expand_all_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconCollapse from './collapse_all_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import monaFavicon from './monaFavicon.png';

// BUILD DECK
function BuildDeck() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const addressMain = state.active.addressMain;

  const deckRef = useRef(null);

  useLayoutEffect(() => {
    // if (heightObservation !== true) return;

    // クリーンアップ用に、現在の参照をローカル変数にコピー
    const currentDeck = deckRef.current;

    // 高さを同期する関数
    const syncHeight = () => {
      if (currentDeck) {
        dispatch({ type: 'setStateMultiLayers', keys: ['deck', 'height'], value: currentDeck.offsetHeight });
      }
    }

    // 初回同期
    syncHeight();

    // ウィンドウリサイズ時にも同期
    window.addEventListener('resize', syncHeight);

    // ResizeObserverでノートヘッダのサイズ変更を監視
    let headerObserver;

    if ('ResizeObserver' in window && currentDeck) {
      headerObserver = new ResizeObserver(syncHeight);
      headerObserver.observe(currentDeck);
    }

    // クリーンアップ
    return () => {
      window.removeEventListener('resize', syncHeight);

      if (headerObserver && currentDeck) {
        headerObserver.unobserve(currentDeck);
      }
    };
  }, []);

  let deck;

  if (state.deck.displayDeck) {
    deck = <Deck addressMain={addressMain} mode='current' />;
  }
  else {
    deck = <div className='flexRow justifyContentFlexEnd alignItemsCenter widthMax ' >
      <ToggleDeckButton />
    </div>
  }

  const headerFixed =
  <div className='z200FixedZero flexColumn alignItemsCenter widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentSpaceBetween widthMax marginBottom1' >
      <div className='flexRow ' >
        <button className='button2' onClick={ () => handleClickDeckNumber(state, dispatch, addressMain) }>
          { words.changeDeck[state.language] }
        </button>
        <button className='button2' onClick={ () => handleClickSaveDeck(state, dispatch) }>
          { words.saveDeck[state.language] }
        </button>
      </div>
      <div className='flexRow ' >
        <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
          { words.back[state.language] }
        </button>
      </div>
    </div>
    <div ref={deckRef} className='flexRow justifyContentCenter width98vw backgroundColorWhite borderKOMFatBorder padding1' >
      { deck }
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax ' style={{ height: `calc(6em + ${state.deck.height}px)` }} >
  </div>;

  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        {/* <Header screen='gallery' /> */}
        <div className='flexColumn alignItemsCenter ' >
          { headerRelative }
          <div className='flexRow justifyContentFlexStart '>
            <Balance addressMain={addressMain} />
          </div>
        </div>
        {/* development */}
        {/*}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        */}
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess ">
        <div className='flexColumn alignItemsCenter ' >
          { headerRelative }
          {/*
            <div className='flexRow justifyContentFlexStart borderKOMFatBorder padding1' >
              <Deck addressMain={state.active.addressMain} mode='current' />
            </div>
          */}
          <div className='flexRow justifyContentFlexStart '>
            <Balance addressMain={addressMain} />
          </div>
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

// TOGGLE DECK BUTTON
function ToggleDeckButton() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);

  let switchIcon;

  if (state.deck.displayDeck) {
    switchIcon = iconCollapse;
  }
  else {
    switchIcon = iconExpand;
  }

  return (
    <button className={'button1'} tabindex='0'
      onClick={ () => {
        dispatch({ type: 'setStateMultiLayers', keys: ['deck', 'displayDeck'], value: state.deck.displayDeck ? false : true });
      }}
    >
      <img className='size2x2' src={switchIcon} alt='' />
    </button>
  );
}

// DECK
function Deck(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const addressMain = props.addressMain;
  let mode = props.mode;
  let deckNo = props.deckNo;

  if (addressMain === undefined || state.deckSet[addressMain]?.currentDeckNo === undefined || state.balance[addressMain] === undefined) {
    return (
      <div className='flexColumn justifyContentCenter alignItemsCenter ' >
        <img className='size2x2' src={monaFavicon} alt='' />
        <div className='' >
          { words.pleaseLogin[state.language] }
        </div>
      </div>
    );
  }
  else {
    // デッキ番号の解決

    if (mode === 'current') {
      if (state.deckSet[addressMain].decks[state.deckSet[addressMain].currentDeckNo] === undefined || state.deckSet[addressMain].decks[state.deckSet[addressMain].currentDeckNo] === null) {
        // 新しいデッキ（番号）を作成したケース
        const deck = {
          deckName: `deck${state.deckSet[addressMain].currentDeckNo}`,
          cards: [
          ],
        };

        dispatch({ type: 'setStateMultiLayers', keys: ['deckSet', addressMain, 'decks', state.deckSet[addressMain].currentDeckNo], value: deck });

        return null;
      }
      else {
        deckNo = state.deckSet[addressMain].currentDeckNo;
      }
    }
    else {
      if (state.deckSet[addressMain].decks[deckNo] === undefined || state.deckSet[addressMain].decks[deckNo] === null) {
        // 新しいデッキ（番号）を作成したケース（存在しないデッキ番号を指定したケース）
        const deck = {
          deckName: `deck${deckNo}`,
          cards: [
          ],
        };

        dispatch({ type: 'setStateMultiLayers', keys: ['deckSet', addressMain, 'decks', deckNo], value: deck });

        return null;
      }
    }
  }

  // デッキの解決

  const deck = state.deckSet[addressMain].decks[deckNo];

  const items = deck.cards.map ( item => <Item item={state.balance[addressMain][item.asset]} size='small' arrows={true} /> );

  // ブランクスロット

  const slotNumbers = [];

  for(let i = 1; i <= state.config.clientParameters.numberOfSlots.advanced; i++) {
    slotNumbers.push(i);
  }

  const blankSlots = slotNumbers.slice(deck.cards.length).map( number => {
    if (number <= 3) {
      return (
        <div>
          {/* PC */}
          <div className="visibleMiddleOrMore">
            <div className='blankSlot border'>
              <div className='font2'>
                { number.toString() + '!' }
              </div>
            </div>
          </div>
          {/* SP */}
          <div className="flexColumn visibleSmallOrLess ">
            <div className='blankSlotSP border'>
              <div className='font2'>
                { number.toString() + '!' }
              </div>
            </div>
          </div>
        </div>
      );
    }
    else {
      return (
        <div>
          {/* PC */}
          <div className="visibleMiddleOrMore">
            <div className='blankSlot border'>
              <div className='font2'>
                { number }
              </div>
            </div>
          </div>
          {/* SP */}
          <div className="flexColumn visibleSmallOrLess ">
            <div className='blankSlotSP border'>
              <div className='font2'>
                { number }
              </div>
            </div>
          </div>
        </div>
      );
    }
  });


  return (
    <div className='widthMax '>
      {/* PC */}
      <div className="visibleMiddleOrMore widthMax ">
        <div className='flexRow justifyContentSpaceBetween widthMax alignItemsCenter ' >
          <TextLine3 fieldName='deckName' keys={['deckSet', addressMain, 'decks', deckNo, 'deckName']} face={words.deckName[state.language]} tooltip='right' />
          <ToggleDeckButton />
        </div>
        <div className='flexRow justifyContentFlexStart alignItemsCenter'>
          { items }
          { blankSlots }
        </div>
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess widthMax ">
        <div className='flexRow justifyContentSpaceBetween widthMax alignItemsCenter '>
          <TextLine3 fieldName='deckName' keys={['deckSet', addressMain, 'decks', deckNo, 'deckName']} face={words.deckName[state.language]} tooltip='right' />
          <ToggleDeckButton />
        </div>
        <div className='flexRow'>
          { items }
          { blankSlots }
        </div>
      </div>
    </div>
  );
}

// BALANCE
function Balance(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const addressMain = props.addressMain;

  if (addressMain === undefined || state.balance[addressMain] === undefined) {
    return null;
  }

  let items =
   Object.values(state.balance[state.active.addressMain])
  .filter( item => state.registeredCard[item.asset] !== undefined )
  .sort( (a, b) => state.registeredCard[a.asset].cardNo - state.registeredCard[b.asset].cardNo )
  // .map ( item => <Item item={item} size='small' quantity={true} arrows={true} />);


  return (
    <div>
      {/* PC */}
      <div
        className="visibleMiddleOrMore"
        style={{ width: '98vw', height: `calc(98vh - 6em - ${state.deck.height}px)`, boxSizing: 'border-box' }} // 6emはheaderRelative
      >
        <FixedGrid items={items} argToCellFunction={{ quantity: true, arrows: true, boxWidth: '14em', cardWidth: '10em' }} >
          { itemInGrid }
        </FixedGrid>
        {/*
          <div className="flexRow justifyContentSpaceAround">
              { items }
          </div>
        */}
      </div>
      {/* SP */}
      <div
        className="flexColumn visibleSmallOrLess "
        style={{ width: '98vw', height: `calc(98vh - 6em - ${state.deck.height}px)`, boxSizing: 'border-box' }} // 6emはheaderRelative
      >
        <FixedGrid items={items} cellWidth={76} cellHeight={115} argToCellFunction={{ quantity: true, arrows: true, boxWidth: '5.2em', cardWidth: '4em', device: 'sp' }} >
          { itemInGrid }
        </FixedGrid>
        {/*
          <div className="flexRow justifyContentSpaceAround">
              { items }
          </div>
        */}
      </div>
    </div>
  );
}

export {
  BuildDeck,
}